import { resolveFofocaStoryMedia } from '@/lib/layouts/resolveFofocaStoryMedia';
import type { PostLayoutConfig } from '@/lib/layouts/types';

type FillerBag = {
  fillerRandomize?: boolean;
  fillerUrl?: string | null;
  fillerUrls?: Array<string | null> | null;
  bottomFillerRandomize?: boolean;
  bottomFillerUrl?: string | null;
  bottomFillerUrls?: Array<string | null> | null;
  imageUrl?: string | null;
};

function hasUrlList(url?: string | null, urls?: Array<string | null> | null): boolean {
  return Boolean(url) || (urls ?? []).some(Boolean);
}

function hasTopFiller(layout: FillerBag): boolean {
  return Boolean(layout.fillerRandomize)
    || hasUrlList(layout.fillerUrl, layout.fillerUrls);
}

function hasBottomFiller(layout: FillerBag): boolean {
  return Boolean(layout.bottomFillerRandomize)
    || hasUrlList(layout.bottomFillerUrl, layout.bottomFillerUrls);
}

/**
 * Templates whose layout needs extra media always leave with a source:
 * random catalog fillers, or an already-authored image/playlist.
 */
export function ensureRequiredTemplateMedia(layout: PostLayoutConfig): PostLayoutConfig {
  if (layout.kind === 'satisfatorio') {
    if (hasTopFiller(layout)) return layout;
    return { ...layout, fillerRandomize: true };
  }

  if (layout.kind === 'triple_split') {
    return {
      ...layout,
      ...(hasTopFiller(layout) ? {} : { fillerRandomize: true }),
      ...(hasBottomFiller(layout) ? {} : { bottomFillerRandomize: true }),
    };
  }

  if (layout.kind === 'fofoca') {
    if (layout.imageUrl && resolveFofocaStoryMedia(layout) === 'image') return layout;
    if (hasTopFiller(layout)) return { ...layout, storyMedia: 'video' };
    return { ...layout, storyMedia: 'video', fillerRandomize: true };
  }

  return layout;
}
